<template>
  <div v-if="visible" :class="['c-auto-sync', `c-auto-sync--${status.toLowerCase()}`]">
    <div class="c-auto-sync__icon">
      <svg v-if="isLoading" class="spinner c-auto-sync__icon--loading" viewBox="0 0 50 50">
        <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
      </svg>
      <TickIcon v-if="isSuccess" class="c-auto-sync__icon--success" />
      <CloseIcon v-if="isError" class="c-auto-sync__icon--error" />
    </div>
    <div class="c-auto-sync__label">
      <div class="c-auto-sync__title">{{ title }}</div>
      <div v-if="isError" class="c-auto-sync__subtitle">{{ subtitle }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import TickIcon from '@/assets/icons/TickIcon.vue';
import CloseIcon from '@/assets/icons/CloseIcon.vue';
import useAutoSync, { AutoSyncStatus } from '@/components/auto-sync/useAutoSync';

const { visible, status, title, subtitle } = useAutoSync();

const isLoading = computed(() => status.value === AutoSyncStatus.LOADING);
const isSuccess = computed(() => status.value === AutoSyncStatus.SUCCESS);
const isError = computed(() => status.value === AutoSyncStatus.ERROR);
</script>
